import { VerityAssessment } from "@verity/api-client/types";
import { useState, useCallback } from "react";

function getQuestionDeliveryDefaults(): QuestionDeliveryInitialValues {
	return {
		shuffleQuestions: true,
		questionsPerPage: null,
	};
}

export function buildQuestionDeliveryInitialValues(verityAssessment?: VerityAssessment): QuestionDeliveryInitialValues {
	const defaults = getQuestionDeliveryDefaults();
	return {
		shuffleQuestions: verityAssessment?.shuffleQuestions ?? defaults.shuffleQuestions,
		questionsPerPage: verityAssessment?.questionsPerPage ?? defaults.questionsPerPage,
	};
}

type QuestionDeliveryInitialValues = {
	shuffleQuestions: boolean;
	questionsPerPage: number | null;
};

export default function useQuestionDelivery(initialValues: QuestionDeliveryInitialValues) {
	const [shuffleQuestions, setShuffleQuestions] = useState<boolean>(initialValues?.shuffleQuestions);
	const [questionsPerPage, setQuestionsPerPage] = useState<number | null>(initialValues?.questionsPerPage);

	const toggleShuffleQuestions = useCallback((shuffle: boolean) => {
		setShuffleQuestions(shuffle);
	}, []);

	const updateQuestionsPerPage = useCallback((num: number | null) => {
		setQuestionsPerPage(num);
	}, []);

	return {
		shuffleQuestions,
		questionsPerPage,
		onShuffleQuestionsChange: toggleShuffleQuestions,
		onQuestionsPerPageChange: updateQuestionsPerPage,
	};
}

export type QuestionDeliveryReturn = ReturnType<typeof useQuestionDelivery>;
